import { useFormSubmit } from "@/hooks/useFormSubmit";
import { organizationInfo } from "@/mocks/home";

const CONTACT_FORM_URL = "https://readdy.ai/api/form/da57hp30muk3qhp2tsbg";

const contactItems = [
  { id: 1, icon: "ri-map-pin-line", label: "Alamat", value: organizationInfo.address },
  { id: 2, icon: "ri-phone-line", label: "Telefon", value: organizationInfo.phone },
  { id: 3, icon: "ri-mail-line", label: "Emel", value: organizationInfo.email },
];

export default function Contact() {
  const { status, errorMsg, handleSubmit } = useFormSubmit(CONTACT_FORM_URL);

  return (
    <section id="hubungi" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="inline-block text-primary-600 text-sm font-semibold uppercase tracking-wider mb-3">
            Hubungi Kami
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
            Kami Sedia Membantu
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600">
            Ada sebarang pertanyaan atau ingin bekerjasama? Hubungi kami atau
            tinggalkan mesej di bawah.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-12">
          {/* Info + map */}
          <div className="w-full lg:w-1/2 space-y-6">
            <div className="space-y-4">
              {contactItems.map((item) => (
                <div key={item.id} className="flex items-start gap-4">
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500 uppercase tracking-wider">
                      {item.label}
                    </p>
                    <p className="text-sm md:text-base text-foreground-900">
                      {item.value}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="w-full h-[260px] md:h-[300px] rounded-lg overflow-hidden border border-background-200">
              <iframe
                title="Lokasi Kelab Kemajuan Insan Malaysia"
                src="https://maps.google.com/maps?q=Bandar%20Damai%20Perdana%2C%2056000%20Kuala%20Lumpur&t=&z=15&ie=UTF8&iwloc=&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
              ></iframe>
            </div>
          </div>

          {/* Form */}
          <div className="w-full lg:w-1/2">
            <form
              id="form-hubungi"
              data-readdy-form
              onSubmit={handleSubmit}
              className="bg-background-100 border border-background-200 rounded-lg p-6 md:p-8"
            >
              <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-900 mb-6">
                Hantar Mesej
              </h3>

              <div className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="ct-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      Nama Penuh
                    </label>
                    <input
                      id="ct-name"
                      name="name"
                      type="text"
                      required
                      placeholder="Nama anda"
                      className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
                    />
                  </div>
                  <div>
                    <label htmlFor="ct-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      Emel
                    </label>
                    <input
                      id="ct-email"
                      name="email"
                      type="email"
                      required
                      placeholder="emel@contoh.com"
                      className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="ct-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    Subjek
                  </label>
                  <input
                    id="ct-subject"
                    name="subject"
                    type="text"
                    placeholder="Tajuk mesej anda"
                    className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
                  />
                </div>

                <div>
                  <label htmlFor="ct-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    Mesej
                  </label>
                  <textarea
                    id="ct-message"
                    name="message"
                    rows={5}
                    required
                    maxLength={500}
                    placeholder="Tulis mesej anda di sini..."
                    className="w-full px-4 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 resize-none"
                  ></textarea>
                </div>

                {/* Anti-spam helper field */}
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="field-aux"
                />

                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="w-full px-6 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {status === "loading" ? "Menghantar..." : "Hantar Mesej"}
                </button>

                {status === "success" && (
                  <p className="text-sm text-primary-600 font-medium text-center">
                    Mesej anda telah dihantar. Terima kasih kerana menghubungi kami!
                  </p>
                )}
                {status === "error" && (
                  <p className="text-sm text-secondary-600 font-medium text-center">
                    {errorMsg}
                  </p>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}